import {useEffect} from 'react'
import {GymReservationForm} from './components/GymReservationForm'
import './GymCheck.scss'

const publicUrl = process.env.PUBLIC_URL || ''
const visitDate = new Intl.DateTimeFormat('id-ID', {
  timeZone: 'Asia/Jakarta',
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
}).format(new Date())

export default function GymCheck() {
  useEffect(() => {
    document.body.classList.remove('page-loading')
    document.getElementById('splash-screen')?.classList.add('hidden')
  }, [])

  return (
    <main className='gym-check-page'>
      <div className='container py-8 py-md-12'>
        <div className='gym-check-shell mx-auto'>
          <header className='text-center mb-7'>
            <img
              src={`${publicUrl}/media/logos/cc58bd4b-3153-43b9-a29c-ff92d723e207.png`}
              className='gym-check-logo img-fluid d-block mx-auto'
              alt='Square Fitness Gym'
            />
            <div className='gym-date-pill d-inline-flex align-items-center gap-2 mt-6'>
              <i className='bi bi-calendar3' aria-hidden='true' />
              <span>{visitDate}</span>
            </div>
            <h1 className='gym-check-title fw-bolder mt-5 mb-3'>Cek Status Membership</h1>
            <p className='gym-check-subtitle mb-0 mx-auto'>
              Masukkan data yang terdaftar untuk melihat status membership Square Gym Anda.
            </p>
          </header>

          <section className='gym-check-card card border-0' aria-labelledby='member-data-title'>
            <div className='card-body p-6 p-md-9'>
              <div className='d-flex align-items-center gap-4 mb-2'>
                <div className='gym-section-icon d-flex align-items-center justify-content-center'>
                  <i className='bi bi-person-check fs-2' aria-hidden='true' />
                </div>
                <div>
                  <h2 id='member-data-title' className='fs-3 fw-bold mb-1'>
                    Data Member
                  </h2>
                  <p className='text-gray-600 mb-0'>Lengkapi data berikut untuk melanjutkan.</p>
                </div>
              </div>
              <GymReservationForm />

              <div className='gym-privacy-note d-flex align-items-start gap-3 mt-6'>
                <i className='bi bi-shield-lock-fill mt-1' aria-hidden='true' />
                <p className='mb-0'>
                  Data Anda hanya digunakan untuk proses pengecekan status membership.
                </p>
              </div>
            </div>
          </section>

          <p className='text-center text-gray-600 fs-7 mt-6 mb-0'>
            Mengalami kendala? Silakan hubungi staf di outlet Square Gym terdekat.
          </p>
        </div>
      </div>
    </main>
  )
}
